// import React, { useState } from "react";
// import { Helmet } from "react-helmet"; // Helmet import

import RandingStyle6NewForm from "../../randing/RandingStyle6NewForm";
import RandingStyle6 from "../../randing/RandingStyle6";

function Randing028({ urlCode, urlCodeSettingId }) {
  return (
    <RandingStyle6
      urlCode={urlCode}
      urlCodeSettingId={urlCodeSettingId}
      img1Path={`${process.env.REACT_APP_CDN_BASE}/images/028/01_241212_01.jpg`}
      img2Path={`${process.env.REACT_APP_CDN_BASE}/images/028/01_241212_02.gif`}
      img3Path={`${process.env.REACT_APP_CDN_BASE}/images/028/01_241212_04.jpg`}
      img4Path={`${process.env.REACT_APP_CDN_BASE}/images/028/01_241212_03.jpg`} // 스텝 변경되는 이미지
      formFieldColor="white"
      qOptionColor="red"
      postBTN={`${process.env.REACT_APP_CDN_BASE}/images/028/postBTN.png`}
      companyName="의정부아이엠치과"
      // footerPath={`${process.env.REACT_APP_CDN_BASE}/images/028/footer.jpg`}
      addClass="mediaQuery028"
    />
  );
}

export default Randing028;
